import { render, staticRenderFns } from "./KaoshiLog.vue?vue&type=template&id=dd0f8f0a&scoped=true&"
import script from "./KaoshiLog.vue?vue&type=script&lang=js&"
export * from "./KaoshiLog.vue?vue&type=script&lang=js&"
import style0 from "./KaoshiLog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./KaoshiLog.vue?vue&type=style&index=1&id=dd0f8f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0f8f0a",
  null
  
)

export default component.exports